import type { OrganizationProfile } from "../../domain/entities/organization-profile";

export abstract class OrganizationProfileRepository {
  abstract getOrganizationProfile(): Promise<OrganizationProfile>;
}
